import API from "./axios";

export const loginUser = async (email, password) => {
  const { data } = await API.post("/auth/login", { email, password });
  localStorage.setItem("accessToken", data.accessToken);
  return data;
};

export const getMe = async () => {
  const { data } = await API.get("/auth/me");
  return data;
};

export const logoutUser = async () => {
  await API.post("/auth/logout");
  localStorage.removeItem("accessToken");
};

export const forgotPassword = async (email) => {
  const { data } = await API.post("/auth/forgot-password", { email });
  return data;
};

export const resetPassword = async (token, password) => {
  const { data } = await API.post("/auth/reset-password", { token, password });
  return data;
};
